import React, { useState, useEffect } from "react";
import toastr from "toastr";
import {
  Alert,
  Button,
  // ButtonGroup,
  Container,
  // Card,
  Col,
  Form,
  Row,
  // Modal,
  Spinner,
  // Dropdown,
  // Tooltip,
  // OverlayTrigger,
  // // ListGroup,
  // Accordion,
  Card,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
// import { get_tasks_descriptors } from "../../redux/tasks/actions";
import { useHistory } from "react-router-dom";
// import LinkDescriptor from "../../components/evaluacion_desempenio/LinkDescriptor";
import TableFormEvalQuestionsFactorComponent from "../../components/evaluacion_desempenio/tableFormEvalFactor";
import {
  getMetricByFactor,
  // getMetricByFactorById,
  // saveMetricByFactor,
  // editMetricByFactor,
  // deleteMetricByFactor,
} from "../../redux/evaluacion_desempenio/MetricByFactor/actions";
// import { Label } from "@material-ui/icons";
import {
  getFormEvalFactor,
  // deleteFormEvalFactor,
  editFormEvalFactor,
  // saveFormEvalFactor,
  // getFormEvalCompeteciaById,
} from "../../redux/evaluacion_desempenio/formularioEval_Factor/actions";
// import { getGeneralInfo } from "../../redux/descriptorsProfiles/GeneralInfo/actions";
// import { getIndikators } from "../../redux/descriptorsProfiles/indikators/actions";
// import { getJobFunction } from "../../redux/descriptorsProfiles/JobFunction/actions";

// import {
//   getFactor,
//   getFactorById,
//   saveFactor,
//   editFactor,
//   deleteFactor,
// } from "../../redux/evaluacion_desempenio/Factor/actions";
// import { handleInputChange } from "react-select/dist/declarations/src/utils";
function useForceUpdate() {
  const [value, setValue] = useState(0); // integer state
  return () => setValue((value) => value + 1); // update state to force render
  // A function that increment 👆🏻 the previous state like here
  // is better than directly setting `setValue(value + 1)`
}
const EvalFormQuestionsFactors = (props) => {
  const [show, setShow] = useState(true);
  const history = useHistory();
  const onShowSidebar = () => setShow(show ? false : true);
  const dispatch = useDispatch();
  // const [loader, setLoader] = useState(null);
  // const [data, setData] = useState([]);
  // //
  // const [limit, setLimit] = useState(10);
  // const [offset, setOffset] = useState(0);
  // const [currentPage, setCurrentPage] = useState(1);
  //
  // const [edit, setEdit] = useState(false);
  // const [index, setIndex] = useState(0);
  // const [editItem, setEditItem] = useState({});
  //
  // const [showFormModal, setShowFormModal] = useState(false);
  // const [validated, setValidated] = useState(false);
  // const [filter, setFilter] = useState("");
  // const [error, setError] = useState("");
  const [arrayGrados, setArrayGrados] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  // Roles
  const userRoles = useSelector((store) => store.auth.userRoles);

  // const { jobFunctionsLength, jobFunctions } = useSelector(
  //   (store) => store.jobFunction
  // );
  // const jobLoading = useSelector((store) => store.jobFunction.loading);

  // const { loaderIndikators, indikators } = useSelector(
  //   (store) => store.indikators
  // );

  const {
    loaderEvalFormFactor,
    evalFormFactor,
    evalFormFactorState,
    // evalFormFactorFalla,
    saveLoaderEvalFormFactor,
    // evalFormFactorFormError,
    nota,
    desempeño,
  } = useSelector((store) => store.evalFormFactor);

  const forceUpdate = useForceUpdate();

  // const {
  //   loading: loadingGeneralInfo,
  //   loadingById: loadingGeneralInfoById,
  //   loadingDescriptionManual,
  //   saveLoading: saveLoadingGeneralInfo,
  //   saveLoadingById,
  //   generalInfosLength,
  //   generalInfo,
  //   generalInfos,
  //   generalInfoError,
  //   formError: formErrorGenetalInfo,
  // } = useSelector((store) => store.generalInfo);

  const { loading, metricByFactors } = useSelector(
    (store) => store.metricByFactor
  );

  useEffect(() => {
    dispatch(
      getFormEvalFactor({
        id: parseInt(props.match.params.id),
      })
    );
    dispatch(
      getMetricByFactor({
        tipo_busqueda: "periodicidad_id",
        filter: parseInt(props.match.params.periodicidad),
      })
    );
    // dispatch(
    //   getGeneralInfo({
    //     tipo_busqueda: "posicion_id",
    //     filter: parseInt(props.match.params.idFuncion),
    //   })
    // );
  }, []);

  // useEffect(() => {
  //   const _length = parseInt(generalInfos.length) - 1;
  //   if (generalInfos.length > 0) {
  //     dispatch(
  //       getIndikators({
  //         tipo_busqueda: "descriptor_id",
  //         filter: parseInt(generalInfos[_length].id),
  //       })
  //     );
  //     dispatch(
  //       getJobFunction({
  //         tipo_busqueda: "descriptor",
  //         filter: parseInt(generalInfos[_length].id),
  //       })
  //     );
  //   }
  // }, [generalInfos]);

  // const _getFactor = (filt = filter) =>
  //   dispatch(
  //     getFactor({
  //       tipo_busqueda: "nombre",
  //       filter: filt,
  //     })
  //   );

  const Options = React.useCallback((val1, val2, index1, index2) => {
    switch (val1.tipo_factor) {
      case 1:
        return (
          <Form.Control
            as="select"
            name="empresa"
            className="col rounded-pill"
            value={arrayGrados[index1][index2].id_origen_pregunta}
            onChange={(e) => {
              const temp = arrayGrados;
              if (
                temp[index1].find(
                  (arr) =>
                    arr.id_origen_pregunta ===
                      parseInt(e.currentTarget.value) &&
                    temp[index1].findIndex(
                      (arr) =>
                        arr.id_origen_pregunta ===
                        parseInt(e.currentTarget.value)
                    ) < 3
                )
              ) {
                toastr.info("Esta función ya fue seleccionada");
                return;
              } else {
                const index3 = temp[index1].findIndex(
                  (t) =>
                    t.id_origen_pregunta === parseInt(e.currentTarget.value)
                );
                const nuevoVal = temp[index1].find(
                  (t) =>
                    t.id_origen_pregunta === parseInt(e.currentTarget.value)
                );
                const num1 = temp[index1][index2].indice_pregunta;
                const num2 = temp[index1][index3].indice_pregunta;
                // temp[index1][index2].idOrigen = parseInt(e.currentTarget.value);
                // nuevoVal.indice_pregunta = num2;
                const nuevoValT1 = {
                  grado: temp[index1][index2].grado,
                  // grado: null,
                  index: temp[index1][index2].index,
                  id_origen_pregunta: nuevoVal.id_origen_pregunta,
                  tipo_factor: temp[index1][index2].tipo_factor,
                  idFactor: temp[index1][index2].idFactor,
                  indice_pregunta: num1,
                };
                const nuevoValT2 = {
                  // grado: temp[index1][index3].grado,
                  grado: null,
                  index: temp[index1][index3].index,
                  id_origen_pregunta: temp[index1][index2].id_origen_pregunta,
                  tipo_factor: temp[index1][index3].tipo_factor,
                  idFactor: temp[index1][index3].idFactor,
                  indice_pregunta: num2,
                };
                // temp[index1][index3].indice_pregunta = num1;
                // temp[index1][index3].grado = null;
                // temp[index1][index3].id_origen_pregunta =
                //   temp[index1][index2].id_origen_pregunta;
                temp[index1][index2] = nuevoValT1;
                temp[index1][index3] = nuevoValT2;
                setArrayGrados(temp);
                forceUpdate(e);
              }
            }}
          >
            <option className="text-muted" value="" selected disabled>
              Selecionar Pregunta
            </option>
            {/* {jobFunctions.length > 0 &&
              jobFunctions
                .filter((f) => f.fundamental === true)
                .map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.descripcion}
                  </option>
                ))} */}
            {val1.preguntas.map((item) => (
              <option
                key={item.id_origen_pregunta}
                value={item.id_origen_pregunta}
              >
                {item.pregunta}
              </option>
            ))}
          </Form.Control>
        );
      case 2:
        return (
          <Form.Control
            as="select"
            name="empresa"
            className="col rounded-pill"
            value={arrayGrados[index1][index2].id_origen_pregunta}
            onChange={(e) => {
              const temp = arrayGrados;
              if (
                temp[index1].find(
                  (arr) =>
                    arr.id_origen_pregunta ===
                      parseInt(e.currentTarget.value) &&
                    temp[index1].findIndex(
                      (arr) =>
                        arr.id_origen_pregunta ===
                        parseInt(e.currentTarget.value)
                    ) < 3
                )
              ) {
                toastr.info("Este indicador ya fue seleccionado");
                return;
              } else {
                const index3 = temp[index1].findIndex(
                  (t) =>
                    t.id_origen_pregunta === parseInt(e.currentTarget.value)
                );
                const nuevoVal = temp[index1].find(
                  (t) =>
                    t.id_origen_pregunta === parseInt(e.currentTarget.value)
                );
                const num1 = temp[index1][index2].indice_pregunta;
                const num2 = temp[index1][index3].indice_pregunta;
                // temp[index1][index2].idOrigen = parseInt(e.currentTarget.value);
                // nuevoVal.indice_pregunta = num2;
                const nuevoValT1 = {
                  grado: temp[index1][index2].grado,
                  // grado: null,
                  index: temp[index1][index2].index,
                  id_origen_pregunta: nuevoVal.id_origen_pregunta,
                  tipo_factor: temp[index1][index2].tipo_factor,
                  idFactor: temp[index1][index2].idFactor,
                  indice_pregunta: num1,
                };
                const nuevoValT2 = {
                  // grado: temp[index1][index3].grado,
                  grado: null,
                  index: temp[index1][index3].index,
                  id_origen_pregunta: temp[index1][index2].id_origen_pregunta,
                  tipo_factor: temp[index1][index3].tipo_factor,
                  idFactor: temp[index1][index3].idFactor,
                  indice_pregunta: num2,
                };
                // temp[index1][index3].indice_pregunta = num1;
                // temp[index1][index3].grado = null;
                // temp[index1][index3].id_origen_pregunta =
                //   temp[index1][index2].id_origen_pregunta;
                temp[index1][index2] = nuevoValT1;
                temp[index1][index3] = nuevoValT2;
                setArrayGrados(temp);
                forceUpdate(e);
              }
            }}
          >
            <option className="text-muted" value="" selected disabled>
              Selecionar Pregunta
            </option>
            {/* {indikators &&
              indikators.data.length > 0 &&
              indikators.data.map((item) => (
                <option key={item.indicador} value={item.indicador}>
                  {item.indicador && item.list_indicador[0].objetivo}
                </option>
              ))} */}
            {val1.preguntas.map((item) => (
              <option
                key={item.id_origen_pregunta}
                value={item.id_origen_pregunta}
              >
                {item.pregunta}
              </option>
            ))}
          </Form.Control>
        );
      default:
        return <>{val2.pregunta}</>;
    }
  });

  var _arrayGrados = [];

  useEffect(() => {
    if (evalFormFactor) {
      evalFormFactor.map((item, index) => {
        let arrayTemp = [];

        item.preguntas
          .sort((a, b) =>
            a.id_detalle_evaluacion_factor < b.id_detalle_evaluacion_factor
              ? 1
              : b.id_detalle_evaluacion_factor < a.id_detalle_evaluacion_factor
              ? -1
              : 0
          )
          .map((_item, _index) => {
            // if (_index < 3) {
            arrayTemp.push({
              grado: _item.metrica_id,
              index: index,
              id_origen_pregunta: _item.id_origen_pregunta,
              tipo_factor: item.tipo_factor,
              idFactor: item.id_factor,
              indice_pregunta: _item.indice_pregunta,
              id_detalle_evaluacion_factor: _item.id_detalle_evaluacion_factor,
            });
            // }
            // } else {
            //   arrayTemp.push("");
            // }
          });
        _arrayGrados.push(arrayTemp);
      });
      setArrayGrados(_arrayGrados);
    }
  }, [evalFormFactor]);

  const onSubmit = () => {
    const req = {
      respuesta_factor: [],
    };
    arrayGrados.map((item, index) => {
      item.map((_item, _index) => {
        //   if ( _item.metrica_id) {
        // if (_index < 3) {
        req.respuesta_factor.push({
          tipo_factor: _item.tipo_factor,
          metrica_factor: _item.grado,
          encabezado_id: parseInt(props.match.params.id),
          id_origen_pregunta: _item.id_origen_pregunta,
          id_factor: _item.idFactor,
          indice_pregunta: _item.indice_pregunta,
        });
        // }
      });
    });
    dispatch(editFormEvalFactor(parseInt(props.match.params.id), req));
    setIsEdit(true);
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 mx-3 d-flex flex-wrap justify-content-start align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              {" "}
            </Row>{" "}
            <Button
              onClick={() => history.goBack()}
              variant="link"
              className="font-weight-bold text-dark"
            >
              <i className="material-icons">arrow_back</i>
            </Button>
            <h6 className="font-weight-bold text-uppercase">
              Formulario de evaluación por factores
            </h6>
          </div>
          <Col sm="12" md="12">
            <hr />
          </Col>
          <div className="my-4 mx-4 border-left border-warning">
            <Alert variant="light">
              <p>
                Seleccione el Nivel que define mejor el desempeño del
                colaborador según el factor, donde muy debajo de las
                expectativas es el nivel más bajo y sobresaliente el nivel más
                alto.
              </p>
            </Alert>
          </div>
          {/* separacion */}
          <Col md="12" className="px-0 mx-auto">
            <Card
              className="border border-muted rounded shadow-sm bg-white"
              style={{ border: "1px solid #ced4da" }}
            >
              <Card.Header className="card-crear text-muted text-uppercase d-flex flex-wrap justify-left-between align-items-left text-justify">
                <h6>Preguntas por factor</h6>
                <div className="ml-auto d-flex flex-wrap justify-content-between align-items-center">
                  <b className="text-light text-uppercase">
                    {nota ? nota + "%" : "no evaluado"}
                    {desempeño && desempeño !== "" ? " - " + desempeño : ""}
                  </b>
                </div>
              </Card.Header>
              <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                <Row className="justify-content-sm-center align-items-center flex-nowrap">
                  <Col md="12">
                    <Row className="mb-0">
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th className="text-center">FACTOR</th>
                            <th className="text-center">DESCRIPCIÓN</th>
                            {userRoles.length > 0 &&
                            (userRoles.includes("administrador") ||
                              userRoles.includes("Responsable_Evaluacion")) ? (
                              <th className="text-center">PESO</th>
                            ) : (
                              <th
                                className="text-center"
                                style={{ display: "none" }}
                              >
                                PESO
                              </th>
                            )}

                            <th className="text-center">PREGUNTA</th>
                            {metricByFactors.map((item) => (
                              <th className="text-uppercase text-center">
                                {item.descripcion}{" "}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        {loaderEvalFormFactor ||
                        // loadingGeneralInfo ||
                        // loaderIndikators ||
                        // jobLoading ||
                        loading ||
                        saveLoaderEvalFormFactor ? (
                          <div className="d-flex justify-content-center">
                            <Spinner
                              animation="border"
                              role="status"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : (
                          <tbody>
                            {evalFormFactor &&
                              arrayGrados.length > 0 &&
                              evalFormFactor.map((item, index) => (
                                <>
                                  <tr>
                                    <td
                                      style={{ minWidth: "200px" }}
                                      rowspan="6"
                                      scope="col"
                                    >
                                      {item.nombre_factor}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td rowspan="6" scope="col">
                                      <div style={{ width: "350px" }}>
                                        {item.descripcion}
                                      </div>
                                    </td>
                                  </tr>
                                  {userRoles.length > 0 &&
                                  (userRoles.includes("administrador") ||
                                    userRoles.includes(
                                      "Responsable_Evaluacion"
                                    )) ? (
                                    <tr>
                                      <td
                                        style={{ minWidth: "100px" }}
                                        rowspan="4"
                                        scope="col"
                                        className="text-center"
                                      >
                                        {item.peso}
                                      </td>
                                    </tr>
                                  ) : (
                                    <tr>
                                      <td
                                        style={{
                                          minWidth: "100px",
                                          display: "none",
                                        }}
                                        rowspan="4"
                                        scope="col"
                                        className="text-center"
                                      >
                                        {item.peso}
                                      </td>
                                    </tr>
                                  )}

                                  {[1, 2, 3].map((_item, _index) => (
                                    <>
                                      <tr>
                                        {(item.preguntas[_index] &&
                                          item.preguntas[_index].metrica_id) ||
                                        !isEdit ? (
                                          <td style={{ minWidth: "300px" }}>
                                            {item.preguntas &&
                                              item.preguntas.sort((a, b) =>
                                                a.id_detalle_evaluacion_factor <
                                                b.id_detalle_evaluacion_factor
                                                  ? 1
                                                  : b.id_detalle_evaluacion_factor <
                                                    a.id_detalle_evaluacion_factor
                                                  ? -1
                                                  : 0
                                              ) &&
                                              item.preguntas.sort((a, b) =>
                                                a.id_detalle_evaluacion_factor <
                                                b.id_detalle_evaluacion_factor
                                                  ? 1
                                                  : b.id_detalle_evaluacion_factor <
                                                    a.id_detalle_evaluacion_factor
                                                  ? -1
                                                  : 0
                                              )[_index] && (
                                                <>
                                                  {props.match.params.type ||
                                                  !evalFormFactorState ? (
                                                    <>
                                                      {
                                                        item.preguntas.sort(
                                                          (a, b) =>
                                                            a.id_detalle_evaluacion_factor <
                                                            b.id_detalle_evaluacion_factor
                                                              ? 1
                                                              : b.id_detalle_evaluacion_factor <
                                                                a.id_detalle_evaluacion_factor
                                                              ? -1
                                                              : 0
                                                        )[_index].pregunta
                                                      }
                                                    </>
                                                  ) : (
                                                    <>
                                                      {item.preguntas.sort(
                                                        (a, b) =>
                                                          a.id_detalle_evaluacion_factor <
                                                          b.id_detalle_evaluacion_factor
                                                            ? 1
                                                            : b.id_detalle_evaluacion_factor <
                                                              a.id_detalle_evaluacion_factor
                                                            ? -1
                                                            : 0
                                                      )[_index] && (
                                                        <>
                                                          {Options(
                                                            item,
                                                            item.preguntas.sort(
                                                              (a, b) =>
                                                                a.id_detalle_evaluacion_factor <
                                                                b.id_detalle_evaluacion_factor
                                                                  ? 1
                                                                  : b.id_detalle_evaluacion_factor <
                                                                    a.id_detalle_evaluacion_factor
                                                                  ? -1
                                                                  : 0
                                                            )[_index],
                                                            index,
                                                            _index
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                          </td>
                                        ) : (
                                          <td
                                            style={{ minWidth: "300px" }}
                                            bgcolor="#96C0DF"
                                          >
                                            {item.preguntas &&
                                              item.preguntas.sort((a, b) =>
                                                a.id_detalle_evaluacion_factor <
                                                b.id_detalle_evaluacion_factor
                                                  ? 1
                                                  : b.id_detalle_evaluacion_factor <
                                                    a.id_detalle_evaluacion_factor
                                                  ? -1
                                                  : 0
                                              ) &&
                                              item.preguntas.sort((a, b) =>
                                                a.id_detalle_evaluacion_factor <
                                                b.id_detalle_evaluacion_factor
                                                  ? 1
                                                  : b.id_detalle_evaluacion_factor <
                                                    a.id_detalle_evaluacion_factor
                                                  ? -1
                                                  : 0
                                              )[_index] && (
                                                <>
                                                  {props.match.params.type ||
                                                  !evalFormFactorState ? (
                                                    <>
                                                      {
                                                        item.preguntas.sort(
                                                          (a, b) =>
                                                            a.id_detalle_evaluacion_factor <
                                                            b.id_detalle_evaluacion_factor
                                                              ? 1
                                                              : b.id_detalle_evaluacion_factor <
                                                                a.id_detalle_evaluacion_factor
                                                              ? -1
                                                              : 0
                                                        )[_index].pregunta
                                                      }
                                                    </>
                                                  ) : (
                                                    <>
                                                      {item.preguntas.sort(
                                                        (a, b) =>
                                                          a.id_detalle_evaluacion_factor <
                                                          b.id_detalle_evaluacion_factor
                                                            ? 1
                                                            : b.id_detalle_evaluacion_factor <
                                                              a.id_detalle_evaluacion_factor
                                                            ? -1
                                                            : 0
                                                      )[_index] && (
                                                        <>
                                                          {Options(
                                                            item,
                                                            item.preguntas.sort(
                                                              (a, b) =>
                                                                a.id_detalle_evaluacion_factor <
                                                                b.id_detalle_evaluacion_factor
                                                                  ? 1
                                                                  : b.id_detalle_evaluacion_factor <
                                                                    a.id_detalle_evaluacion_factor
                                                                  ? -1
                                                                  : 0
                                                            )[_index],
                                                            index,
                                                            _index
                                                          )}
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </>
                                              )}
                                          </td>
                                        )}

                                        <TableFormEvalQuestionsFactorComponent
                                          item={item.preguntas[_index]}
                                          metrica={metricByFactors}
                                          index={_index}
                                          metrica_id={
                                            item.preguntas[_index]
                                              ? item.preguntas[_index]
                                                  .metrica_id
                                              : null
                                          }
                                          factor={item}
                                          indexFactor={index}
                                          arrayGrados={arrayGrados}
                                          setArrayGrados={setArrayGrados}
                                          type={
                                            props.match.params.evaluationType
                                          }
                                          isDisabled={!evalFormFactorState}
                                          isEdit={isEdit}
                                          setIsEdit={isEdit}
                                        />
                                      </tr>
                                    </>
                                  ))}
                                </>
                              ))}
                          </tbody>
                        )}
                      </Table>
                    </Row>
                  </Col>
                </Row>
                {loaderEvalFormFactor ||
                (props.match.params.evaluationType &&
                  parseInt(props.match.params.evaluationType) === 2) ||
                !evalFormFactorState ? null : (
                  <>
                    <Button
                      className="rounded-pill mt-2"
                      disabled={saveLoaderEvalFormFactor}
                      variant="warning"
                      onClick={() => onSubmit()}
                    >
                      {saveLoaderEvalFormFactor && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          align-items="right"
                        />
                      )}
                      Guardar evaluacion
                    </Button>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Container>
      </div>
    </>
  );
};

export default EvalFormQuestionsFactors;
